import React from "react";
import InputForm from "../../common/InputForm";
import ModalToChange from "../../Layout/ModalToChange";
import { CheckBoxInput, SelectForm } from "../../common/Buttons";

class RivileServiceEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      id: 0,
      id_product: "",
      title: "",
      rivile_code: "",
      order_shop_ids: undefined,
      alt_code: "",
      alt_price: "",
      has_vat: false,
      action: "new",
      errors: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.action === "new" && this.state.action === "edit") {
      this.setState({
        id: 0,
        id_product: "",
        title: "",
        rivile_code: "",
        order_shop_ids: undefined,
        has_vat: "",
        alt_code: "",
        alt_price: "",
        action: "new",
        errors: {},
      });
    } else if (
      nextProps.action === "edit" &&
      nextProps.objectData.id !== this.state.id
    ) {
      this.setState({
        id: nextProps.objectData.id,
        id_product: nextProps.objectData.id_product,
        title: nextProps.objectData.title,
        rivile_code: nextProps.objectData.rivile_code,
        order_shop_ids:
          nextProps.objectData.order_shops_rivile_services?.map(
            (e) => e.order_shop_id
          ) || [],
        has_vat: nextProps.objectData.has_vat,
        alt_code: nextProps.objectData.alt_code,
        alt_price: nextProps.objectData.alt_price,
        action: "edit",
        errors: {},
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  buildOrderShopsAtr = () => {
    let current =
      this.state.order_shop_ids?.map((order_shop_id) => ({
        order_shop_id,
        rivile_service_id: this.state.id || null,
      })) || [];
    const old = this.props.objectData?.order_shops_rivile_services || [];

    old.forEach((old_props) => {
      const findIndex = current.findIndex(
        (d) => d.order_shop_id == old_props.order_shop_id
      );
      if (findIndex == -1) {
        current.push({
          id: old_props.id,
          _destroy: true,
        });
      } else {
        current[findIndex].id = old_props.id;
      }
    });
    return current;
  };

  onSubmit = (e) => {
    e.preventDefault();

    let errors = {};
    if (!this.state.title) errors.title = "Field is empty";
    if (!this.state.rivile_code) errors.rivile_code = "Field is empty";
    if (!this.state.id_product) errors.id_product = "Field is empty";
    if (!this.state.order_shop_ids || this.state.order_shop_ids?.length == 0)
      errors.order_shop_id = "No store selected";
    if (Object.entries(errors).length > 0) {
      return this.setState({
        errors,
      });
    }
    const variables = {
      rivile_service: {
        id_product: this.state.id_product,
        title: this.state.title,
        rivile_code: this.state.rivile_code,
        // order_shop_id: this.state.order_shop_id,
        alt_code: this.state.alt_code,
        alt_price: this.state.alt_price,
        has_vat: this.state.has_vat,
        order_shops_rivile_services_attributes: this.buildOrderShopsAtr(),
      },
    };
    if (this.props.action == "new") {
      this.props.postRivileService(variables).then((res) => {
        if (res.success) {
          this.setState({
            id: 0,
            id_product: "",
            title: "",
            rivile_code: "",
            has_vat: "",
            alt_code: "",
            alt_price: "",
            action: "new",
            errors: {},
          });
        }
      });
    } else if (this.props.action === "edit") {
      this.props.updateRivileServices(this.state.id, variables).then((res) => {
        if (res.success) {
          this.setState({
            errors: {},
          });
        }
      });
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={this.props.action === "new" ? "Create new" : "Edit"}
        buttonText={this.props.action === "new" ? "Create" : "Update"}
      >
        <SelectForm
          mode="multiple"
          type="text"
          placeholder="Store"
          name="order_shop_id"
          value={this.state.order_shop_ids}
          error={errors.order_shop_id}
          onChange={(value) =>
            this.handleChange({ target: { name: "order_shop_ids", value } })
          }
          options={this.props.shops}
        />
        <InputForm
          type="text"
          placeholder="Product ID"
          name="id_product"
          value={this.state.id_product}
          error={errors.id_product}
          onChange={(e) => this.handleChange(e)}
        />
        <div className="py-2" />
        <InputForm
          type="text"
          placeholder="Title"
          name="title"
          value={this.state.title}
          error={errors.title}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Rivile code"
          name="rivile_code"
          value={this.state.rivile_code}
          error={errors.rivile_code}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="number"
          placeholder="Alternative price"
          name="alt_price"
          value={this.state.alt_price}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Alternative code"
          name="alt_code"
          value={this.state.alt_code}
          onChange={(e) => this.handleChange(e)}
        />
        <CheckBoxInput
          checked={this.state.has_vat}
          name={"has_vat"}
          onChange={(e) => this.setState({ has_vat: e.target.checked })}
          text="VAT applies"
        />
      </ModalToChange>
    );
  }
}

export default RivileServiceEditModal;
